import React, { useEffect, useState } from "react";
import axios from "axios";
import "./UserPaymentHistory.css";
import MainNavbar from "../MainNavbar";

const UserPaymentHistory = () => {
  const [history, setHistory] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [page, setPage] = useState(1);

  const itemsPerPage = 6;

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?._id;

  useEffect(() => {
    if (!userId) return;

    axios
      .get(`https://back.varankal.com/api/payments/user/${userId}`, {
        withCredentials: true,
      })
      .then((res) => setHistory(res.data))
      .catch((err) => console.log("Error fetching payment history:", err));
  }, [userId]);

  // ---------------- FILTER ----------------
  const filteredHistory = history
    .filter((item) =>
      item.planName?.toLowerCase().includes(search.toLowerCase())
    )
    .filter((item) => {
      if (filter === "active") return item.isActive === true;
      if (filter === "expired") return item.isActive === false;
      return true;
    });

  // ---------------- PAGINATION ----------------
  const startIndex = (page - 1) * itemsPerPage;
  const paginatedData = filteredHistory.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://back.varankal.com/api/payments/${id}`);
      setHistory(history.filter((item) => item._id !== id));
    } catch (err) {
      console.log("Error deleting:", err);
    }
  };

  return (
    <>
      <MainNavbar />

      <div className="uph-wrapper fade-in">

        {/* ===== PAGE HEADER ===== */}
        <div className="uph-header">
          <h2>Your Payment History</h2>

          <input
            type="text"
            placeholder="Search plans..."
            className="uph-search-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* ===== FILTER BUTTONS ===== */}
        <div className="uph-filter-box">
          <button
            className={filter === "all" ? "uph-filter active" : "uph-filter"}
            onClick={() => setFilter("all")}
          >
            All
          </button>

          <button
            className={filter === "active" ? "uph-filter active" : "uph-filter"}
            onClick={() => setFilter("active")}
          >
            Active
          </button>

          <button
            className={
              filter === "expired" ? "uph-filter active" : "uph-filter"
            }
            onClick={() => setFilter("expired")}
          >
            Expired
          </button>
        </div>

        {/* ===== TABLE CARD ===== */}
        <div className="uph-card">
          <table className="uph-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Amount</th>
                <th>Start</th>
                <th>Expiry</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item) => (
                  <tr
                    key={item._id}
                    className={item.isActive ? "uph-row-active" : ""}
                  >
                    <td>{item.planName}</td>
                    <td>₹{item.amountPaid}</td>
                    <td>{new Date(item.startDate).toLocaleDateString()}</td>
                    <td>{new Date(item.expiryDate).toLocaleDateString()}</td>

                    <td
                      className={
                        item.isActive
                          ? "uph-status-active"
                          : "uph-status-expired"
                      }
                    >
                      {item.isActive ? "Active" : "Expired"}
                    </td>

                    <td className="uph-actions">
                      {!item.isActive && (
                        <button
                          className="uph-btn-upgrade"
                          onClick={() => (window.location.href = "/subscription")}
                        >
                          Upgrade
                        </button>
                      )}

                      <button
                        className="uph-btn-delete"
                        onClick={() => handleDelete(item._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="uph-empty" colSpan="6">
                    No payment records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ===== PAGINATION CONTROL ===== */}
        {filteredHistory.length > 0 && (
          <div className="uph-pagination">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="uph-page-btn1"
            >
              Prev
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={page === i + 1 ? "uph-page-number active" : "uph-page-number"}
                onClick={() => setPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="uph-page-btn1"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default UserPaymentHistory;
